// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-sidebar {
  z-index: 999;
  /* z-index: 1998; */
  margin-top: 74px;
  background-color: #E0DFE0;
}

.sidebar-toggle {
  margin-left: -240px;
}

.os-host-overflow-x .lbl-menu, .sidebar-collapse .lbl-menu{
  display: none !important;
}
/* .header {
  opacity: 0;
  background-color: #E0DFE0;
} */

.sidebar {
  width: 100%;
  height: calc(100% - 74px);
  padding: 0;
  position: absolute;
  transition: all 0.3s ease-in-out;
  z-index: 100;
  /* margin-top: 68px; */
  padding-top: 20px;
  /* background-color: #E0DFE0; */
}

.sidebar #leftside-navigation ul {
  margin: 0 10px;
  padding: 0;
  /* width: 215px; */
  /* background-color: red; */
}
.sidebar #leftside-navigation ul ul {
  margin: 0;
  padding: 0;
}
.sidebar #leftside-navigation ul li {
  list-style-type: none;
  margin-top: 5px;
  /* margin-bottom: 10px; */
}
.sidebar #leftside-navigation ul li a{
  height: 35px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 1px #b8b8b8;
  /* border-bottom: 1px solid #bd0000; */
  align-content: center;
  color: black !important;
}
.sidebar #leftside-navigation ul li a:hover{
  background-color: #00000016;
  color: #bd0000 !important;
}
i.arrow {
  float: right;
  float: right;
  margin: 4px 0;
  text-align: center;
}
.sidebar #leftside-navigation ul.sub-menu-child li a {
  margin-left: 30px;
  justify-content: center;
  background-color: transparent;
}
.sidebar #leftside-navigation ul.sub-menu-child li a:hover {
  margin-left: 30px;
  justify-content: center;
  background-color: #0000000c;

}
.sidebar #leftside-navigation ul.sub-menu-child li {
  margin-top: 0;
  /* margin-bottom: 10px; */
  margin-right: 0;
}
.sub-menu-child {
  display: none;
  padding-left: 15px;
}
.sub-menu-child.show {
  display: block;
}
.arrow {
  transition: transform 0.3s ease;
}

.sidebar #leftside-navigation ul li a {
  text-decoration: none;
  display: block;
  padding: 7px 0 7px 20px;
  font-size: 14px;
  font-weight: 500;
  outline: 0;
  transition: all 200ms ease-in;
  /* border-bottom: 1px solid #edf1f7; */
}
/* .sidebar #leftside-navigation ul li a span {
  display: inline-block;
  padding-bottom: 50px;
} */
.sidebar #leftside-navigation ul li a i {
  width: 20px;
}
.sidebar #leftside-navigation ul li a i .fa-angle-left,
.sidebar #leftside-navigation ul li a i .fa-angle-right {
  padding-top: 3px;
}
.sidebar #leftside-navigation ul ul {
  display: none;
}
.sidebar #leftside-navigation ul ul li {
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  border-bottom: none;
}
.sidebar #leftside-navigation ul ul li a {
  box-shadow: none;
}

.sidebar #leftside-navigation ul li.active a{
  background: #bd0000;
  color: #ffffff !important;
}
.sidebar #leftside-navigation ul li.active a:hover{
  background-color: #00000016;
  color: #bd0000 !important;
}
.img-footer {
  position: absolute;
  bottom: 0;
  z-index: 999;
  width: 100%;
  text-align: center;
  padding: 20px 0;
}

.hide-owner, .hide-admin{
  display: none;
}

@media screen and (max-width: 1550px) {
  .sidebar{
    overflow-y: scroll;
  }
}

@media screen and (max-width: 730px) {
  .sidebar {
    /* margin-top: 100px; */
    margin-top: 0;
    height: calc(100% - 20px);
  }
  .header img {
    width: 150px;
  }
  .header {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }
}

@media screen and (max-width: 900px) {
  .mi-cuenta {
    display: block;
  }
}

.hide-cliente, .hide-admin{
  display: none;
}

.show-cliente, .show-admin{
  display: block;
}

.logo-app img {
  width: 140px;
  margin: 5px;
}

.movile{
  width: 40%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/appmenu/appmenu.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;AACA;;;GAGG;;AAEH;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAKlB,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;EAC7B,sCAAsC;EACtC,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;;AAE7B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;EAKV,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;;;GAGG;AACH;EACE,WAAW;AACb;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".main-sidebar {\n  z-index: 999;\n  /* z-index: 1998; */\n  margin-top: 74px;\n  background-color: #E0DFE0;\n}\n\n.sidebar-toggle {\n  margin-left: -240px;\n}\n\n.os-host-overflow-x .lbl-menu, .sidebar-collapse .lbl-menu{\n  display: none !important;\n}\n/* .header {\n  opacity: 0;\n  background-color: #E0DFE0;\n} */\n\n.sidebar {\n  width: 100%;\n  height: calc(100% - 74px);\n  padding: 0;\n  position: absolute;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  z-index: 100;\n  /* margin-top: 68px; */\n  padding-top: 20px;\n  /* background-color: #E0DFE0; */\n}\n\n.sidebar #leftside-navigation ul {\n  margin: 0 10px;\n  padding: 0;\n  /* width: 215px; */\n  /* background-color: red; */\n}\n.sidebar #leftside-navigation ul ul {\n  margin: 0;\n  padding: 0;\n}\n.sidebar #leftside-navigation ul li {\n  list-style-type: none;\n  margin-top: 5px;\n  /* margin-bottom: 10px; */\n}\n.sidebar #leftside-navigation ul li a{\n  height: 35px;\n  border-radius: 5px;\n  background-color: rgba(255, 255, 255, 0.3);\n  box-shadow: 0 2px 1px #b8b8b8;\n  /* border-bottom: 1px solid #bd0000; */\n  align-content: center;\n  color: black !important;\n}\n.sidebar #leftside-navigation ul li a:hover{\n  background-color: #00000016;\n  color: #bd0000 !important;\n}\ni.arrow {\n  float: right;\n  float: right;\n  margin: 4px 0;\n  text-align: center;\n}\n.sidebar #leftside-navigation ul.sub-menu-child li a {\n  margin-left: 30px;\n  justify-content: center;\n  background-color: transparent;\n}\n.sidebar #leftside-navigation ul.sub-menu-child li a:hover {\n  margin-left: 30px;\n  justify-content: center;\n  background-color: #0000000c;\n\n}\n.sidebar #leftside-navigation ul.sub-menu-child li {\n  margin-top: 0;\n  /* margin-bottom: 10px; */\n  margin-right: 0;\n}\n.sub-menu-child {\n  display: none;\n  padding-left: 15px;\n}\n.sub-menu-child.show {\n  display: block;\n}\n.arrow {\n  transition: transform 0.3s ease;\n}\n\n.sidebar #leftside-navigation ul li a {\n  text-decoration: none;\n  display: block;\n  padding: 7px 0 7px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  outline: 0;\n  -webkit-transition: all 200ms ease-in;\n  -moz-transition: all 200ms ease-in;\n  -o-transition: all 200ms ease-in;\n  -ms-transition: all 200ms ease-in;\n  transition: all 200ms ease-in;\n  /* border-bottom: 1px solid #edf1f7; */\n}\n/* .sidebar #leftside-navigation ul li a span {\n  display: inline-block;\n  padding-bottom: 50px;\n} */\n.sidebar #leftside-navigation ul li a i {\n  width: 20px;\n}\n.sidebar #leftside-navigation ul li a i .fa-angle-left,\n.sidebar #leftside-navigation ul li a i .fa-angle-right {\n  padding-top: 3px;\n}\n.sidebar #leftside-navigation ul ul {\n  display: none;\n}\n.sidebar #leftside-navigation ul ul li {\n  margin-bottom: 0;\n  margin-left: 0;\n  margin-right: 0;\n  border-bottom: none;\n}\n.sidebar #leftside-navigation ul ul li a {\n  box-shadow: none;\n}\n\n.sidebar #leftside-navigation ul li.active a{\n  background: #bd0000;\n  color: #ffffff !important;\n}\n.sidebar #leftside-navigation ul li.active a:hover{\n  background-color: #00000016;\n  color: #bd0000 !important;\n}\n.img-footer {\n  position: absolute;\n  bottom: 0;\n  z-index: 999;\n  width: 100%;\n  text-align: center;\n  padding: 20px 0;\n}\n\n.hide-owner, .hide-admin{\n  display: none;\n}\n\n@media screen and (max-width: 1550px) {\n  .sidebar{\n    overflow-y: scroll;\n  }\n}\n\n@media screen and (max-width: 730px) {\n  .sidebar {\n    /* margin-top: 100px; */\n    margin-top: 0;\n    height: calc(100% - 20px);\n  }\n  .header img {\n    width: 150px;\n  }\n  .header {\n    display: flex;\n    justify-content: center;\n    padding: 20px 0;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .mi-cuenta {\n    display: block;\n  }\n}\n\n.hide-cliente, .hide-admin{\n  display: none;\n}\n\n.show-cliente, .show-admin{\n  display: block;\n}\n\n.logo-app img {\n  width: 140px;\n  margin: 5px;\n}\n\n.movile{\n  width: 40%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
